import {useCallback,useEffect,useRef} from 'react';
export default function useCommerceScope(user){
 const account=String(user?.id??user?.customerId??user?.userId??'');
 const identity=useRef(account),active=useRef(true);identity.current=account;
 useEffect(()=>{active.current=true;return()=>{active.current=false;};},[]);
 const current=useCallback(()=>active.current&&identity.current===account,[account]);
 return {account,current};
}
